import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { formatCurrency } from "../../utils";

export const DailyProfitChart = ({ dashboard }) => {
  // Transform API data to format for Recharts
  const data = dashboard?.daily_profit?.map((item) => ({
    date: new Date(item.date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    }),
    profit: parseFloat(item.profit_usdt),
  }));

  return (
    <div className="w-full h-[300px] md:h-[400px] px-2 md:px-4">
      <ResponsiveContainer width="100%" height="100%" className={"ml-[-2rem]"}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 10 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip
            formatter={(value) => `${formatCurrency(value)} USDT`}
            labelFormatter={(label) => (
              <div className="text-xs">Date: {label}</div>
            )}
            contentStyle={{
              fontSize: "12px",
              borderRadius: "8px",
              padding: "8px",
            }}
          />
          <Bar
            dataKey="profit"
            radius={[10, 10, 0, 0]}
            shape={(props) => {
              const { x, y, width, height, fill, payload } = props;
              const isNegative = payload.profit < 0;
              return (
                <rect
                  x={x}
                  y={isNegative ? y + height : y}
                  width={width}
                  height={Math.abs(height)}
                  fill={isNegative ? "#EF4444" : "#302571"}
                  rx={6}
                  ry={6}
                />
              );
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
